export const BackArrow = ({ fill = 'white' }) => (
    <svg width="12" height="22" viewBox="0 0 12 22" fill="none">
        <path
            d="M0.806143 11.0743C0.806143 11.3219 0.905178 11.5695 1.10327 11.7676L9.17565 20.781C9.57184 21.2267 10.3147 21.2762 10.7604 20.88C11.2061 20.4838 11.2557 19.741 10.8595 19.2953L3.4309 11.0743L10.8595 2.85335C11.2557 2.40763 11.2557 1.66477 10.7604 1.26858C10.2652 0.872393 9.57184 0.872393 9.17565 1.36763L1.10327 10.3314C0.905178 10.48 0.806143 10.7772 0.806143 11.0743Z"
            fill={fill}
        />
    </svg>
);
